module.exports = __webpack_public_path__ + "img/barIcon1.6c30dfca.png";